/* global $ */
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import './../game/dashboard.css'

import { DateRangePicker } from 'react-date-range'
import React, { Component } from 'react'

const { apiget } = global.rootRequire('classes/request')
const { AdminBlock } = global.rootRequire('components/shares/rxTemplates')
const { MainTable } = global.rootRequire('components/shares/rxTemplates')

const ulti = require('../game/dashboardUlti').default
const rxu = global.rxu

class MediationStatsComponent extends Component {
  constructor(props) {
    super(props)

    this.toDate = new Date()
    this.toDate1Ago = new Date()
    this.toDate1Ago.setDate(this.toDate1Ago.getDate() - 1)

    this.toDate7Ago = new Date()
    this.toDate7Ago.setDate(this.toDate7Ago.getDate() - 7)

    this.toDate30Ago = new Date()
    this.toDate30Ago.setDate(this.toDate30Ago.getDate() - 30)

    this.toDate90Ago = new Date()
    this.toDate90Ago.setDate(this.toDate90Ago.getDate() - 90)

    this.state = {
      selectionRange: {
        startDate: this.toDate30Ago,
        endDate: this.toDate1Ago,
        key: 'selection'
      },
      chartData: null,
      tableData: [],
      adSources: [],
      accounts: [],
      loading: false,
      flags: {}
    }
  }

  toggle(flagname) {
    const flags = this.state.flags
    flags[flagname] = flags[flagname] ? 0 : 1
    this.setState({ flags: flags })
  }

  flag(flagname) {
    return rxu.get(this.state, ['flags', flagname], 0)
  }

  handleSelect(ranges) {
    this.clearCanvasDom()
    this.setState({
      selectionRange: ranges.selection
    }, () => {
      this.fetchData()
    })
  }

  componentDidMount() {
    if ($(window).width() > 1000) {
      this.isFullview = true
      $('.beside').addClass('rxsideactive')
      $('.bemain').addClass('rxsideactive')
      $('.adtopbar__togglesidebar').addClass('rxsideactive')
      $('.adtopbar__logo').addClass('rxsideactive')
    }
    this.fetchData()
  }

  componentWillUnmount() {
    if ($(window).width() > 1000 && this.isFullview) {
      $('.beside').removeClass('rxsideactive')
      $('.bemain').removeClass('rxsideactive')
      $('.adtopbar__togglesidebar').removeClass('rxsideactive')
      $('.adtopbar__logo').removeClass('rxsideactive')
    }
  }

  fetchData() {
    this.setState({ loading: true }, () => {
      const params = {
        startDate: this.state.selectionRange.startDate,
        endDate: this.state.selectionRange.endDate
      }

      apiget(rxu.get(rxu.config, 'api_mediation_stats'), params, {
        1: (json) => {
          this.setState({
            chartData: json.data.chart,
            tableData: json.data.table.data || [],
            adSources: json.data.table.adSources || [],
            accounts: json.data.accounts || [],
            loading: false
          }, () => {
            this.initChart(json.data.chart)
          })
        },
        '-1': () => {
          this.setState({ loading: false })
        }
      })
    })
  }

  initCharBlock(item, index, color) {
    return {
      lineTension: 0,
      data: item,
      label: index,
      backgroundColor: global.rxu.strRgbaAddAlpha(color, 0.1),
      borderColor: color,
      borderWidth: 2.5,
      pointBackgroundColor: global.rxu.strRgbaAddAlpha(color, 1),
      pointBorderWidth: 1,
      fill: false
    }
  }

  initCharOption(options) {
    return {
      elements: { point: { radius: 2, zIndex: 100 } },
      maintainAspectRatio: false,
      title: { display: false },
      tooltips: {
        position: 'nearest',
        mode: 'index',
        intersect: false,
        callbacks: {
          label: function (tooltipItem, chart) {
            var dataLabel = `${chart.datasets[tooltipItem.datasetIndex].label}` || ''
            return dataLabel + ': $' + ulti.number_format_round(tooltipItem.yLabel, 2)
          }
        }
      },
      legend: {
        display: true,
        position: 'top',
        labels: { pointBorderWidth: 0, boxWidth: 12, boxHeight: 12, marginBottom: 0, fontSize: 12, usePointStyle: false, marginRight: 15 }
      },
      hover: { mode: 'nearest', intersect: true },
      interaction: { mode: 'nearest', intersect: true },
      scales: {
        xAxes: [{ ticks: { fontColor: 'rgba(150,150,150,0.7)', minRotation: 30, autoSkip: true, maxTicksLimit: 15 }, display: true, gridLines: { display: false }, stacked: options.stacked || false }],
        yAxes: [{ ticks: { callback: function (value) { return '$' + ulti.number_format(value) }, fontColor: 'rgba(0,0,0,0.8)', min: 0, autoSkip: true, maxTicksLimit: 10 }, display: true, gridLines: { display: true, color: 'rgba(150,150,200,0.2)', lineWidth: 0.5 }, stacked: options.stacked || false }]
      }
    }
  }

  initChart(chartConfig) {
    if (!chartConfig) return

    const options = this.initCharOption(chartConfig.options || {})
    const chartData = chartConfig.data
    const labelArray = chartConfig.label
    const labelId = 'chart_mediation'

    // Clear existing chart
    if (typeof (this[labelId]) !== 'undefined') {
      this[labelId].destroy()
    }

    $('#chartShow').html('')

    let strChart = `
    <div class='col-md-12'>
      <div class='chart__item'>
        <div class='chart__title'>${chartConfig.name}</div>
        <div class='chart__content'><canvas id='${labelId}' width='600' height='350' /></div>
      </div>
    </div>`

    $('#chartShow').append(strChart).ready(() => {
      const ctx = document.getElementById(labelId)
      if (!ctx) return

      const chartDataset = []
      if (chartData && chartData.length > 0) {
        chartData.forEach((item, index) => {
          const currentColor = ulti.strToRgb(item.label || '')
          chartDataset.push(this.initCharBlock(item.data, item.label, currentColor))
        })
      }

      const config = {
        type: 'LineWithLine',
        options: options,
        hover: { mode: 'nearest', intersect: true },
        data: { labels: labelArray, datasets: chartDataset }
      }

      this[labelId] = new global.Chart(ctx.getContext('2d'), config)
    })
  }

  clearCanvasDom() {
    const labelId = 'chart_mediation'
    if (typeof (this[labelId]) !== 'undefined') {
      this[labelId].destroy()
    }
  }

  renderTable() {
    return <MainTable><thead>{this.renderTableHead()}</thead><tbody>{this.renderTableBody()}</tbody><tfoot>{this.renderTableFooter()}</tfoot></MainTable>
  }

  renderTableHead() {
    const adSources = this.state.adSources
    return <tr>
      <th className='rxwidth--50'>STT</th>
      <th className='rxwidth--150'>Account</th>
      <th className='rxwidth--100'>Total Rev</th>
      {adSources.map((source, i) => (
        <th key={i} className='rxwidth--100'>{source}</th>
      ))}
    </tr>
  }

  renderTableBody() {
    const tableData = this.state.tableData
    const adSources = this.state.adSources

    return global.rxu.array(tableData).map((row, i) => {
      return <tr key={i}>
        <td>{i + 1}</td>
        <td className='rxcenter'><b>{row.account_name}</b></td>
        <td className='rxcenter'><b>${ulti.number_format_round(row.total, 2)}</b></td>
        {adSources.map((source, j) => (
          <td key={j} className='rxcenter'>${ulti.number_format_round(row[source] || 0, 2)}</td>
        ))}
      </tr>
    })
  }

  renderTableFooter() {
    const tableData = this.state.tableData
    const adSources = this.state.adSources

    let grandTotal = 0
    const adSourceTotals = {}

    global.rxu.array(tableData).forEach((row) => {
      grandTotal += row.total || 0
      adSources.forEach((source) => {
        adSourceTotals[source] = (adSourceTotals[source] || 0) + (row[source] || 0)
      })
    })

    return <tr>
      <th className='rxcenter'>Total</th>
      <th className='rxcenter'></th>
      <th className='rxcenter'><b>${ulti.number_format_round(grandTotal, 2)}</b></th>
      {adSources.map((source, i) => (
        <th key={i} className='rxcenter'>${ulti.number_format_round(adSourceTotals[source] || 0, 2)}</th>
      ))}
    </tr>
  }

  render() {
    return (
      <>
        {this.state.loading && <div className='bg_loading'><div className='rxloading'></div></div>}
        <AdminBlock name='Mediation Stats' desc='Revenue statistics by Admob accounts and Ad Sources' exclass='adsticky'>

          <div className='row'>
            <div className='filtersum__block'>
              <div className='showFilterBtn attop icon-magnifier-add' />
              <div className='filtersum__date'>
                <b>Date</b> {this.state.selectionRange.startDate.toLocaleDateString('vi-VN')} - {this.state.selectionRange.endDate.toLocaleDateString('vi-VN')}
              </div>
            </div>
          </div>

          <div className='row' id='chartShow' />

          <div className='showFilterBtn icon-magnifier-add' />
          <div className='showFilter'>
            <div className='filterWrap'>
              <div className='filterLabel'>Date Range</div>
              <DateRangePicker
                staticRanges={[
                  { ...staticRangeHandler, label: 'Today', range: () => ({ startDate: this.toDate, endDate: this.toDate }) },
                  { ...staticRangeHandler, label: 'Yesterday', range: () => ({ startDate: this.toDate1Ago, endDate: this.toDate1Ago }) },
                  { ...staticRangeHandler, label: 'Last 7 days', range: () => ({ startDate: this.toDate7Ago, endDate: this.toDate1Ago }) },
                  { ...staticRangeHandler, label: 'Last 30 days', range: () => ({ startDate: this.toDate30Ago, endDate: this.toDate1Ago }) },
                  { ...staticRangeHandler, label: 'Last 90 days', range: () => ({ startDate: this.toDate90Ago, endDate: this.toDate1Ago }) }
                ]}
                ranges={[this.state.selectionRange]}
                onChange={this.handleSelect.bind(this)}
              />
            </div>
          </div>

          <div className='rxcol-100'>
            <div className='betable'>
              <div className='adblock__head'>
                <div className='adblock__title'>Revenue by Admob Account & Ad Source</div>
                <div className='adblock__desc'>Summary table showing revenue breakdown</div>
              </div>
              {this.renderTable()}
            </div>
          </div>

        </AdminBlock>
      </>
    )
  }
}

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range()
    return (
      isSameDay(range.startDate, definedRange.startDate) &&
      isSameDay(range.endDate, definedRange.endDate)
    )
  }
}

function isSameDay(date1, date2) {
  try {
    return (date1.toString() === date2.toString())
  } catch (e) {
    return false
  }
}

export default MediationStatsComponent
